import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconTextBeta = createSVG({
    width: 48,
    children: (jsx("path", { d: "M11.745 11.777c.702-.566 1.131-1.371 1.131-2.4C12.876 7.371 11.247 6 9.225 6H4.493v12h5.092c2.074 0 3.737-1.423 3.737-3.48 0-1.251-.617-2.194-1.577-2.743m-2.52-3.566c.754 0 1.285.566 1.285 1.32s-.548 1.32-1.285 1.32H6.859v-2.64zm.36 7.578H6.859V12.96h2.726c.805 0 1.388.6 1.388 1.406 0 .823-.583 1.423-1.388 1.423m7.653-.052v-2.691h4.543v-2.229h-4.543V8.263h4.972V6h-7.337v12h7.423v-2.263zM31.9 6h-8.828v2.263h3.223V18h2.365V8.263h3.24zm9.035 12h2.572L39.289 6h-2.931l-4.2 12h2.554l.72-2.16h4.783zm-4.748-4.371 1.645-4.903 1.646 4.903z" })),
});

export { IconTextBeta };
